<template>
    <el-tooltip
        v-bind="attrs"
        v-on="listeners"
    >
        <!-- 提示信息 -->
        <div
            v-if="$slots.content"
            slot="content"
        >
            <slot name="content">
            </slot>
        </div>

        <!-- 显示内容 -->
        <wx-calc-ellipsis
            ref="WxCalcEllipsis"
            @mouseenter.native="handleCalcToolTip"
        >
            <slot></slot>
        </wx-calc-ellipsis>
    </el-tooltip>

</template>

<script>
export default {
    inheritAttrs: false,
    data() {
        return {
            canShowTooltip: true,
        };
    },
    computed: {
        attrs() {
            const res = { ...this.$attrs };
            delete res.content;

            return {
                "open-delay": 500,
                effect: "dark",
                placement: "top",
                ...res,
                "popper-class": [
                    this.canShowTooltip ? "" : "dn",
                    this.$attrs["popper-class"],
                ]
                    .filter((v) => v)
                    .join(" "),
            };
        },
        listeners() {
            return {
                ...this.$listeners,
            };
        },
    },
    methods: {
        async handleCalcToolTip() {
            const hasEllipsis = await this.$refs.WxCalcEllipsis.hasEllipsis();
            this.canShowTooltip = hasEllipsis;
        },
    },
};
</script>